<app-filter-bar
  searchLabel="Search by queue, topic or subscription"
  [chips]="chips()"
  [allCount]="matchCount()"
  [allPressed]="selected().size === 0"
  [selects]="selects()"
  [shown]="visible().length"
  [total]="entities().length"
  [hasFilter]="hasFilter()"
  [(query)]="query"
  (toggleChip)="toggleFilter($event)"
  (clearChips)="clearFilter()"
  (clearAll)="clearAll()"
  (selectChange)="change($event)"
/>

@if (visible().length === 0) {
  <p class="state">
    No queues or topics match your search or filter.
    <button type="button" class="link" (click)="clearAll()">Clear filters</button>
  </p>
} @else {
  <div class="grid">
    @for (entity of visible(); track entity.namespace + '|' + entity.kind + '|' + entity.name) {
      <app-dead-letter-card [entity]="entity" [now]="now()" [staleAfterMs]="staleAfterMs()" />
    }
  </div>
}
